import React, {useState} from 'react';
import {Field} from '@parallelpublicworks/entitysync'
import {MultiSelectRelationship, SelectRelationship, TextField, TextAreaField, TextSubField, CheckboxField, NumberField, DisplayIfEqualsField, DisplayIfExistsField} from "../components/carbon-entitysync";
import {SelectItem, FormGroup, Tile, InlineNotification, Button} from 'carbon-components-react';
import { graphql, useStaticQuery } from 'gatsby'
import { Location32, } from "@carbon/icons-react";
import { setGeocodedLocations } from "../util/setGeocodedLocations";


export default function SubmitListingForm({isNew, validationState: validationState, geolocationState}){
  const data = useStaticQuery(graphql`
    query TaxonomyQuery {
      allTaxonomyTermApplicationMethods {
        nodes {
          drupal_id  
          name
        }
      }
      allTaxonomyTermCategories {
        nodes {
          drupal_id
          name
        }
      }
      allTaxonomyTermEducationLevels {
        nodes {
          drupal_id
          name
        }
      }
      allTaxonomyTermBilingual {
        nodes {
          drupal_id
          name
        }
      }
      allTaxonomyTermExperienceLevels {
        nodes {
          drupal_id
          name
        }
      }
      allTaxonomyTermExperienceYears {
        nodes {
          drupal_id
          name
        }
      }
      allTaxonomyTermExpirationLengths {
        nodes {
          drupal_id
          name
        }
      }
      allTaxonomyTermPositionTypes {
        nodes {
          drupal_id
          name
        }
      }
      allTaxonomyTermSalaryTypes {
        nodes {
          drupal_id
          name
        }
      }  
    }
  `);

  const mapTerm = (n) => {
    return {id: n.drupal_id, ...n};
  };
  const [locations, setLocations] = geolocationState;
  const onChangeAddress = () => {
    if(!document){
      return;
    }
    validationStateSetters.field_address(false);
    validationStateSetters.field_location(false);
    if (locations.length) setLocations([])
  };

  const verifyAddress = () => {
    if (!document) {
      return
    }
    setGeocodedLocations(setLocations);
  }

  const applyDocs = ['Cover letter', 'Resume'];
  const categories = data.allTaxonomyTermCategories.nodes.map(mapTerm);
  const educationLevels = data.allTaxonomyTermEducationLevels.nodes.map(mapTerm);
  const bilingualOptions = data.allTaxonomyTermBilingual.nodes.map(mapTerm);
  const experienceLevels = data.allTaxonomyTermExperienceLevels.nodes.map(mapTerm);
  const experienceYears = data.allTaxonomyTermExperienceYears.nodes.map(mapTerm);
  const salaryTypes = data.allTaxonomyTermSalaryTypes.nodes.map(mapTerm);
  const positionTypes = data.allTaxonomyTermPositionTypes.nodes.map(mapTerm);
  const applicationMethods = data.allTaxonomyTermApplicationMethods.nodes.map(mapTerm);
  const expirationLengths = data.allTaxonomyTermExpirationLengths.nodes.map(mapTerm);
  const validationStateVals = {};
  const validationStateSetters = {};
  for(let key of Object.keys(validationState)){
    validationStateVals[key] = validationState[key][0];
    validationStateSetters[key] = validationState[key][1];
  }
  return (
    <form className="submit-form submit-listing-form">
      <TextField light
                 labelText="Job title"
                 placeholder="Enter title"
                 invalid={validationStateVals.title}
                 invalidText={validationStateVals.title ? validationStateVals.title : ""}
                 onChange={() => validationStateSetters.title(false)}
                 field="title"/>
      <TextField light
                 labelText="Company name"
                 placeholder="Company name"
                 invalid={validationStateVals.field_company_name}
                 invalidText={validationStateVals.field_company_name ? validationStateVals.field_company_name : ""}
                 onChange={() => {
                   validationStateSetters.field_company_name(false)
                 }}
                 field="field_company_name"/>

      <MultiSelectRelationship light
            isNew={isNew}
            titleText="Categories"
            label="Select Categories"
            relType="taxonomy_term--categories"
            field="field_category"
            invalid={validationStateVals.field_category}
            invalidText={validationStateVals.field_category ? validationStateVals.field_category : ""}
            onChange={() => validationStateSetters.field_category(false)}
            items={
              categories.map((category) => {
                return {
                  label: category.name,
                  id: category.id
                }
              })
            }
      />
      <MultiSelectRelationship light
      size="sm" 
        isNew={isNew}
        titleText="Position Types"
        label="Select Positions"
        relType="taxonomy_term--position_types"
        field="field_position"
        invalid={validationStateVals.field_position}
        invalidText={validationStateVals.field_position ? validationStateVals.field_position : ""}
        onChange={() => validationStateSetters.field_position(false)}
        items={
            positionTypes.map((category) => {
            return {
              label: category.name,
              id: category.id
            }
          })
        }
      />
      <Field field="field_address">
        <FormGroup className="address-field"  legendText="">
          <TextSubField light
                        invalid={validationStateVals.field_address}
                        onChange={onChangeAddress}
                        labelText="Job location"
                        subField="address_line1"
                        placeholder="Street (optional)"/>
          <TextSubField light
                        invalid={validationStateVals.field_address}
                        onChange={onChangeAddress}
                        labelText=""
                        subField="locality"
                        placeholder="City (optional)" />
          <TextSubField light
                        invalid={validationStateVals.field_address}
                        onChange={onChangeAddress}
                        labelText=""
                        subField="postal_code"
                        placeholder="Zipcode" />
          <div style={{ paddingTop: "1rem" }}><Button onClick={verifyAddress}>Confirm Address</Button></div>
        </FormGroup>
      </Field>
      {
        validationStateVals.field_location && <InlineNotification title={validationStateVals.field_location} kind="error" lowContrast/>
      }
      {
        locations.length ? (
          <h3>Your location</h3>
        ) : (
          <h3>No location found, please confirm address</h3>
        )
      }
      {
        locations.map((location) => {
          return (
            <Tile light>
              <Location32/>
              {location.formatted_address}
            </Tile>
          );
        })
      }
      
      <TextAreaField light
                     charLimit={2000}
                     labelText="Description"
                     placeholder="Please describe the position in simple terms without using acronyms in 2,000 words or less. (Please note that copying and pasting bullets from other sources may result in formatting errors.)"
                     invalid={validationStateVals.field_description}
                     onChange={() => validationStateSetters.field_description(false)}
                     invalidText={validationStateVals.field_description ? validationStateVals.field_description : ""}
                     field="field_description"/>
      <TextAreaField light
                     charLimit={2000}
                     labelText="Required qualifications"
                     placeholder="Please describe what is required to be hired for this position. Consider age, educational requirements, potential background requirements, etc. (Please note that copying and pasting bullets from other sources may result in formatting errors.)"
                     invalid={validationStateVals.field_required_qualifications}
                     onChange={() => validationStateSetters.field_required_qualifications(false)}
                     invalidText={validationStateVals.field_required_qualifications ? validationStateVals.field_required_qualifications : ""}
                     field="field_required_qualifications"/>
      <TextAreaField light
                     charLimit={2000}
                     labelText="Preferred qualifications (optional)"
                     placeholder="Please describe the preferred qualifications for this position, for example bilingual skills, education, experience, etc. (Please note that copying and pasting bullets from other sources may result in formatting errors.)"
                     invalid={validationStateVals.field_preferred_qualifications}
                     onChange={() => validationStateSetters.field_preferred_qualifications(false)}
                     invalidText={validationStateVals.field_preferred_qualifications ? validationStateVals.field_preferred_qualifications : ""}
                     field="field_preferred_qualifications"/>
      <TextAreaField light
                     charLimit={2000}
                     labelText="Benefits (optional)"
                     placeholder="What are the benefits offered? (Please use bullets provided in the form. Please note that copying and pasting from other sources may result in formatting errors.)"
                     invalid={validationStateVals.field_benefits}
                     onChange={() => validationStateSetters.field_benefits(false)}
                     invalidText={validationStateVals.field_benefits ? validationStateVals.field_benefits : ""}
                     field="field_benefits"/>
      <SelectRelationship
                   light
                   charLimit={2000}
                   labelText="Education"
                   defaultValue="placeholder-item"
                   invalid={validationStateVals.field_education}
                   relType="taxonomy_term--education_levels"
                   onChange={() => validationStateSetters.field_education(false)}
                   invalidText={validationStateVals.field_education? validationStateVals.field_education: ""}
                   field="field_education" >
        <SelectItem
          disabled
          hidden
          value="placeholder-item"
          text="Level"
        />
        {
          educationLevels.map((educationLevel) => (<SelectItem text={educationLevel.name} key={educationLevel.id} value={educationLevel.id} />))
        }
      </SelectRelationship>
      <SelectRelationship
        light
        charLimit={2000}
        labelText="Bilingual (optional)"
        defaultValue="placeholder-item"
        invalid={validationStateVals.field_bilingual}
        relType="taxonomy_term--bilingual"
        onChange={() => validationStateSetters.field_bilingual(false)}
        invalidText={validationStateVals.field_bilingual ? validationStateVals.field_bilingual : ""}
        field="field_bilingual" >
        <SelectItem
          
          value="placeholder-item"
          text="N/A"
        />
        {
        bilingualOptions.map((bilingualOp) => (<SelectItem text={bilingualOp.name} key={bilingualOp.id} value={bilingualOp.id} />))
        }
      </SelectRelationship>
      <FormGroup className="experience"  legendText="">
        <SelectRelationship
                     light
                     labelText="Experience (optional)"
                     relType="taxonomy_term--experience_levels"
                     defaultValue="placeholder-item"
                     invalid={validationStateVals.field_experience_level}
                     onChange={() => validationStateSetters.field_experience_level(false)}
                     invalidText={validationStateVals.field_experience_level ? validationStateVals.field_experience_level : ""}
                     field="field_experience_level">
          <SelectItem
            disabled
            hidden
            value="placeholder-item"
            text="Level"
          />
          {
            experienceLevels.map((experienceLevel) => (<SelectItem text={experienceLevel.name} key={experienceLevel.id} value={experienceLevel.id} />))
          }
        </SelectRelationship>
      </FormGroup>
      <SelectRelationship light
                    labelText="Experience Years  (optional)"
                    defaultValue="placeholder-item"
                    relType="taxonomy_term--experience_years"
                    invalid={validationStateVals.field_experience_years}
                    onChange={() => validationStateSetters.field_experience_years(false)}
                    invalidText={validationStateVals.field_experience_years ? validationStateVals.field_experience_years : ""}
                    field="field_experience_years">
        <SelectItem
          disabled
          hidden
          value="placeholder-item"
          text="Years"
        />
        {
          experienceYears.map((experienceYears) => (<SelectItem text={experienceYears.name} key={experienceYears.id} value={experienceYears.id} />))
        }
      </SelectRelationship>
      <SelectRelationship light
                   labelText="Salary type (optional)"
                   onChange={(e) => validationStateSetters.field_salary_type(false)}
                   relType="taxonomy_term--salary_types"
                   defaultValue="placeholder-item"
                   invalid={validationStateVals.field_salary_type}
                   invalidText={validationStateVals.field_salary_type ? validationStateVals.field_salary_type : ""}
                   field="field_salary_type">
        <SelectItem
          disabled
          hidden
          value="placeholder-item"
          text="Select type"
        />
        
        {
          salaryTypes.map((salaryType) => (<SelectItem text={salaryType.name} key={salaryType.id} value={salaryType.id} />))
        }
      </SelectRelationship>


      <DisplayIfEqualsField field="field_salary_type" like={['hourly', 'salary']} isRelationship={true} terms={salaryTypes} strict >

        <div class="range-fields">
            <label class="bx--label">Salary range (USD):</label>
            <div class="range-field">
              <NumberField
                        light
                        id="min-salary-range"
                        field="field_salary_number"
                        onChange={() => validationStateSetters.field_salary_number(false)}
                        invalid={validationStateVals.field_salary_number}
                        invalidText={validationStateVals.field_salary_number ? validationStateVals.field_salary_number : ""}
                        allowEmpty
                        placeholder="Min."
              />
            </div>
            <div class="range-field">
              <NumberField
                        light
                        id="max-salary-range"
                        field="field_salary_number_max"
                        onChange={() => validationStateSetters.field_salary_number_max(false)}
                        invalid={validationStateVals.field_salary_number_max}
                        invalidText={validationStateVals.field_salary_number_max ? validationStateVals.field_salary_number_max : ""}
                        allowEmpty 
                        placeholder="Max."
                />
            </div>

        </div>
        <div class="bx--form__helper-text">Use monthly rate for Salary option</div>

      </DisplayIfEqualsField>





      <SelectRelationship light
                   labelText="How to Apply"
                   defaultValue="placeholder-item"
                   relType="taxonomy_term--application_methods"
                   invalid={validationStateVals.field_application_method}
                   onChange={() => validationStateSetters.field_application_method(false)}
                   invalidText={validationStateVals.field_application_method ? validationStateVals.field_application_method : ""}
                   field="field_application_method">
        <SelectItem
          disabled
          hidden
          value="placeholder-item"
          text="Select method"
        />
        {
          applicationMethods.map((applicationMethod) => (<SelectItem text={applicationMethod.name} key={applicationMethod.id} value={applicationMethod.id} />))
        }
      </SelectRelationship>

      <DisplayIfEqualsField field="field_application_method" like="board" isRelationship={true} terms={applicationMethods} >
        <fieldset className={`bx--fieldset ${validationStateVals.field_required_documents ? 'bx--fieldset--invalid' : ''}`} >
          <legend className="bx--label">Required Documents</legend>
          {applyDocs.map((doc) => {
            return <CheckboxField
              field="field_required_documents"
              labelText={doc}
              id={doc}
              key={doc}
              value={doc}
              onChange={() => validationStateSetters.field_required_documents(false)}
            />
          })}
        </fieldset>
      </DisplayIfEqualsField>

      <DisplayIfEqualsField field="field_application_method" like="external" isRelationship={true} terms={applicationMethods} >
        <TextField light
                  labelText="External Application URL"
                  placeholder="http://"
                  isUrl={true}
                  invalid={validationStateVals.field_application_url}
                  invalidText="Please add a valid URL including http:// at the start"
                  onChange={() => validationStateSetters.field_application_url(false)}
                  field="field_application_url"/>
      </DisplayIfEqualsField>

      <SelectRelationship light
                   labelText="Automated expiration"
                   defaultValue="placeholder-item"
                   relType="taxonomy_term--expiration_lengths"
                   invalid={validationStateVals.field_expiration}
                   onChange={() => validationStateSetters.field_expiration(false)}
                   invalidText={validationStateVals.field_expiration ? validationStateVals.field_expiration : ""}
                   field="field_expiration">
        <SelectItem
          disabled
          hidden
          value="placeholder-item"
          text="Set length"
        />
        {
          expirationLengths.map((expirationLength) => (<SelectItem text={expirationLength.name} key={expirationLength.id} value={expirationLength.id} />))
        }
      </SelectRelationship>
    </form>
  );
}

